__turbopack_context__.v({
  "heading": "xZdzJG_heading",
  "headingContainer": "xZdzJG_headingContainer",
  "sellingItemImage": "xZdzJG_sellingItemImage",
  "soldOutImageContainer": "xZdzJG_soldOutImageContainer",
});
